// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3D8CN","additionalInfo":"AgreementModal_additionalInfo__2KF6C"};